<img src="assets/imgs/sign-in.png" width="60" height="60" />
<h1>sign in</h1>
<br />
<p>
  if you do not have an account yet, you can register for one or continue with
  your Google account.
</p>
<br />
<!-- email/password -->
<kor-input
  label="email"
  type="email"
  name="email"
  (input)="credentials.email = $event.target.value"
></kor-input>
<kor-input
  label="password"
  type="password"
  name="password"
  (input)="credentials.password = $event.target.value"
></kor-input>
<br />
<kor-button
  class="stretch"
  label="sign in"
  (click)="
    signIn('email', credentials);
    sharedService.logEvent('sign_in_button_clicked')
  "
></kor-button>
<kor-button
  class="stretch"
  color="secondary"
  label="register"
  (click)="register.emit(); sharedService.logEvent('register_launch')"
></kor-button>
<!-- auth providers -->
<br />
<hr />
<br />
<kor-button
  class="stretch google"
  label="continue with google"
  (click)="signIn('google'); sharedService.logEvent('google_button_clicked')"
></kor-button>
